<template>
  <v-menu
    v-model="menuOpen"
    location="bottom start"
    :close-on-content-click="true"
    transition="scale-transition"
  >
    <template #activator="{ props: activatorProps }">
      <v-btn
        v-bind="activatorProps"
        variant="outlined"
        rounded="lg"
        class="filter-style-btn"
        :disabled="!hiddenFields.length"
      >
        <v-icon
          icon="mdi-format-list-bulleted"
          start
        />
        Add Profile Field
      </v-btn>
    </template>
    <v-card
      min-width="200"
      max-height="320"
      class="dropdown-card"
    >
      <v-list class="py-0 dropdown-list">
        <v-list-item
          v-for="field in hiddenFields"
          :key="field.id"
          class="dropdown-list-item"
          @click="handleAddField(field.id)"
        >
          <span class="item-label text-body-2">{{ field.label }}</span>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useTracking } from '@/stores/tracking/tracking';

const props = defineProps({
  fields: {
    type: Array,
    default: () => [],
  },
  visibleIds: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['toggle-field']);

const menuOpen = ref(false);

const visibleSet = computed(() => new Set(props.visibleIds || []));

const hiddenFields = computed(() => (props.fields || []).filter(
  (field) => field?.id && !visibleSet.value.has(field.id),
));

const handleAddField = (id) => {
  useTracking().jaMatrixAddedJobProfileField();

  emit('toggle-field', id, true);
  menuOpen.value = false;
};
</script>

<style scoped lang="less">
.filter-style-btn {
  height: 40px !important;
  min-height: 40px !important;
  background-color: @bg-default !important;
  border: 1px solid @stroke-default;
  color: @text-darkest;
  font-weight: 400;
  text-transform: none;
}

.dropdown-card {
  border: 0 !important;
  box-shadow: 0 10px 50px 0 fade(@grey-900, 10%) !important;
  border-radius: 8px;
}

.dropdown-list {
  max-height: 280px;
  overflow-y: auto;
  border-radius: 8px;
}

.dropdown-list-item {
  min-height: 36px;
  height: 36px;
  padding: 0 12px;
  cursor: pointer;
}

.item-label {
  color: fade(@grey-700, 95%);
}

.dropdown-list-item:hover .item-label {
  color: @text-brand;
}
</style>
